export default __webpack_public_path__ + "static/media/modal-top-image.8ef75741.jpg";